/**
 * useBriefly - true for `ms` after a value crosses an edge (the Track Z simplify: the reload's refill, the curtain
 * opening from its line, the magazine control's flash - three copies of one timer, each keeping it its own way).
 *
 * `rose(was, now)` says whether the change from the value last seen is the edge; the first value seen never is. The
 * timer lives in a ref, so a re-render or a later change that is no edge never cuts it short (gotcha: a timer
 * cleared in an effect's cleanup dies with the effect's next run); a fresh edge restarts it.
 *
 * @returns whether the moment is on
 */
import { useEffect, useRef, useState } from 'react';

export default function useBriefly<T>(value: T, rose: (was: T, now: T) => boolean, ms: number): boolean {
  const was = useRef(value);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);
  const [on, setOn] = useState(false);
  useEffect(() => {
    const edge = rose(was.current, value);
    was.current = value;
    if (!edge) return;
    clearTimeout(timer.current);
    setOn(true);
    timer.current = setTimeout(() => setOn(false), ms);
  }, [value, rose, ms]);
  useEffect(() => {
    const t = timer;
    return () => clearTimeout(t.current);
  }, []);
  return on;
}
